import styled from 'styled-components';

export const StyledList = styled.ul`
  margin: 0;
  margin-bottom: 0.8rem;
  padding: 0;
  padding-left: 2.4rem;
`;
